import { PATH_PAGE } from 'src/routes/paths';

/**
 * Soft navigation helper for Access Denied (/403).
 * Used for route-level permission failures (PermissionGuard), not background API errors.
 * navigate is injected from inside BrowserRouter (Axios403Handler).
 */

let navigateRef = null;

export function setAccessDeniedNavigate(navigate) {
  navigateRef = typeof navigate === 'function' ? navigate : null;
}

export function redirectToAccessDenied() {
  const target = PATH_PAGE.page403;
  try {
    if (typeof window !== 'undefined') {
      const current = window.location.pathname || '';
      if (current === target || current.endsWith(target)) {
        return;
      }
    }
  } catch (e) {
    // ignore
  }

  if (navigateRef) {
    navigateRef(target, { replace: true });
    return;
  }

  if (typeof window !== 'undefined') {
    window.location.assign(target);
  }
}
